<template>
  <div class="flex items-center">
    <Select
      v-if="isGuide"
      :model-value="modelValue ? 'true' : 'false'"
      @update:model-value="updateStatus"
    >
      <SelectTrigger
        class="w-fit rounded-full hover:outline hover:outline-4 hover:outline-gray-100 border-0 shadow-none flex items-center min-w-16 h-fit py-1 text-white pl-2 pr-1 border-[1px]"
        :class="{ 'bg-lime-500 border-lime-500': modelValue, 'bg-red-500 border-red-500': !modelValue }"
      >
        <span class="text-xs text-center w-full capitaliz">
          {{ modelValue ? 'Open' : 'Closed' }}
        </span>
      </SelectTrigger>

      <SelectContent class="w-32 z-[9999]">
        <SelectGroup>
          <SelectItem value="true" class="p-0 focus:bg-transparent focus:text-inherit hover:bg-transparent data-[highlighted]:bg-transparent data-[highlighted]:text-inherit">
            <button class="text-left px-2 rounded-full hover:outline hover:outline-4 hover:outline-gray-100 cursor-pointer text-xs py-1 w-full my-1 flex items-center justify-between bg-lime-500 text-white">
              Open
            </button>
          </SelectItem>
          <SelectItem value="false" class="p-0 focus:bg-transparent focus:text-inherit hover:bg-transparent data-[highlighted]:bg-transparent data-[highlighted]:text-inherit">
            <button class="text-left px-2 rounded-full hover:outline hover:outline-4 hover:outline-gray-100 cursor-pointer text-xs py-1 w-full my-1 flex items-center justify-between bg-red-500 text-white">
              Closed
            </button>
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>

    <span
      v-else
      class="text-white rounded-full px-2 py-1 text-xs block w-14 text-center capitalize border-[1px]"
      :class="{
        'bg-lime-500 border-lime-500': modelValue,
        'bg-red-500 border-red-500': !modelValue
      }"
    >
      {{ modelValue ? 'Open' : 'Closed' }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { useRolesStore } from '@/stores/roles'
import { toast } from '@/components/ui/toast'

const props = defineProps<{
  modelValue: boolean
  roleId: number | string
}>()

const { isGuide } = useAuth()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const rolesStore = useRolesStore()

async function updateStatus(value: any) {
  if (value == null) return
  const newStatus = String(value) === 'true'
  const previous = props.modelValue
  // Optimistically update parent v-model
  emit('update:modelValue', newStatus)

  try {
    await rolesStore.updateRole(String(props.roleId), {
      status_open: newStatus
    })
    toast({
      title: 'Success',
      description: `Job status updated to ${newStatus ? 'Open' : 'Closed'}`
    })
  } catch (error) {
    // Rollback on error
    emit('update:modelValue', previous)
    toast({
      variant: 'destructive',
      title: 'Error',
      description: 'Failed to update job status'
    })
  }
}
</script> 